module.exports = __webpack_public_path__ + "img/9788982738999.2cb42abf.jpg";